module.exports = __webpack_public_path__ + "media/images/about-slider-img-07-748d22331213eb83115d04c44ee73b5f.jpg";